import { Tooltip } from '@chakra-ui/react';
import React from 'react';
import styled from 'styled-components';

import AccessibilityIcon from './acessibility-icon';

const AcessibilityContainer = styled.div`
  cursor: pointer;
`;

export const AcessibilityMenu = () => {
  const showEqualWebDrawer = (): void => {
    const element = document.getElementById('INDmenu-btn');
    if (element) element.click();
  };

  return (
    <Tooltip label="Acessibilidade" hasArrow placement="bottom-end" bg="black">
      <AcessibilityContainer onClick={showEqualWebDrawer} aria-label="Menu de acessibilidade">
        <span>
          <AccessibilityIcon />
        </span>
      </AcessibilityContainer>
    </Tooltip>
  );
};
